import { computed, toValue } from 'vue'
import { get as _get, set as _set } from 'lodash'

export function useProcedureTransactionPaymentMethod ({ procedure_execution }) {
  const paymentMethod = computed({
    get: () => _get(toValue(procedure_execution), 'actions_data.transaction.payment_method'),
    set: payment_method => _set(toValue(procedure_execution), 'actions_data.transaction.payment_method', toValue(payment_method))
  })

  const paymentMethodInformations = computed({
    get: () => _get(toValue(procedure_execution), 'actions_data.transaction.payment_method_informations', {}),
    set: informations => _set(toValue(procedure_execution), 'actions_data.transaction.payment_method_informations', toValue(informations))
  })

  const isSepaDebitPaymentMethod = computed(() => ['sepa_dd', 'sepa_debit'].includes(paymentMethod.value))

  const isBancontactPaymentMethod = computed(() => ['bancontact', 'bancontactmrcash'].includes(paymentMethod.value))

  return {
    paymentMethod,
    paymentMethodInformations,
    isSepaDebitPaymentMethod,
    isBancontactPaymentMethod
  }
}